const brandIcons = [
  "facebook-f",
  "google",
  "houzz",
  "instagram",
  "linkedin-in",
  "pinterest-p",
  "snapchat",
  "strava",
  "tiktok",
  "tumblr",
  "twitter",
  "weibo",
  "weixin",
  "youtube"
];

export { brandIcons };
